import { createContext, useContext } from 'react'

export type IndexName = string & { _protect: '' }

export type WidgetConfig = {
  appId: string
  apiKey: string
  baseUrl: string
  baseUrls: Record<string, string>
  postsPerPage: number
  indexName: IndexName
  contactUrl: string
  icons: Record<string, string>
  imgixSrcUrl: string
  imgixTargetUrl: string
  siteUrl: string
  organisationId: string | number | null
  typePreFilter?: 'offers' | 'events'
  filterLayout?: 'full' | 'without_group_filters' | 'without_filters' | 'without_filters_and_search'
  emptyText?: string
}

const ConfigContext = createContext<WidgetConfig>({
  appId: '',
  apiKey: '',
  baseUrl: '',
  baseUrls: {},
  postsPerPage: 10,
  indexName: 'events' as IndexName,
  contactUrl: '',
  icons: {},
  imgixSrcUrl: '',
  imgixTargetUrl: '',
  siteUrl: '',
  organisationId: null,
  typePreFilter: undefined
})

export function useConfigContext() {
  return useContext(ConfigContext)
}

/** Which parts of the filter UI a layout shows — shared by FilterPanel and SearchUI. */
export function getFilterLayoutFlags(
  filterLayout: WidgetConfig['filterLayout']
) {
  const layout = filterLayout ?? 'full'
  return {
    showGroupFilter: layout === 'full',
    // The filter bar and the mobile action buttons that open it appear together.
    showFilterBar: layout === 'full' || layout === 'without_group_filters',
    showSearchPanel: layout !== 'without_filters_and_search'
  }
}

export const ConfigProvider = ConfigContext.Provider
